import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import HomeCard from '../../components/HomeCard';

const styles = css`
  padding: 90px 0;
`;

function HomesResults({ homes, limit, showMore }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row justify-content-center">
          {
            orderBy(homes, ['address.addressLocality', 'containedIn.name', 'moveInDate']).slice(0, limit).map(home => (
              <div key={home._id} className="col-lg-4">
                <HomeCard home={home} />
              </div>
            ))
          }
        </div>
      </div>
      {
        limit < homes.length &&
        <div className="Button_wrapper">
          <button className="btn" onClick={showMore}>Load All {homes.length} Homes</button>
        </div>
      }
    </div>
  );
}

HomesResults.propTypes = {
  limit: PropTypes.number.isRequired,
  showMore: PropTypes.func,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

HomesResults.defaultProps = {
  showMore: [],
};

export default withData(
  {
    homes: true,
    limit: true,
  },
  {
    required: {
      homes: true,
    },
  },
)(HomesResults);



// WEBPACK FOOTER //
// ./src/pages/Homes/HomeResults.js